class SimilarIdeas
{
	nameSelector;
	containerSelector;
	endpoint;

	constructor(endpoint, nameSelector, containerSelector)
	{
		this.endpoint = endpoint;
		this.nameSelector = nameSelector;
		this.containerSelector = containerSelector;
	}

	init()
	{
		const thisObj = this;

		$(function ()
		{
			$(thisObj.nameSelector).on("change", thisObj._onNameChanged.bind(thisObj));
		})
	}

	_onNameChanged(e)
	{
		const name = $(this.nameSelector).val();
		if (name.length > 3) {
			this._requestSimilarIdeas(name);
		} else {
			this._hideContainer();
		}
	}

	_hideContainer()
	{
		$(this.containerSelector).hide();
	}

	_showContainer()
	{
		$(this.containerSelector).show();
	}

	_requestSimilarIdeas(name)
	{
		dataAction.callClientPostEndpoint(
			this.endpoint,
			{
				name: name,
			},
			this._showSimilarIdeas.bind(this),
			this._onError.bind(this)
		);
	}

	_showSimilarIdeas(ideas)
	{
		if (ideas && ideas.length > 0) {
			this._showContainer();
			const $container = $(this.containerSelector);
			const $list = $container.find(".list");
			const $template = $list.find(".template");
			const $link = $list.find(".link");
			$list.children(":not(.template)").remove();
			for (var i = 0; i < Math.min(5, ideas.length); i++) {
				$link.html(ideas[i]['name']);
				$link.attr("href", ideas[i]['link']);
				const $clone = $template.clone(true, true);
				$clone.removeClass("template");
				$clone.appendTo($list);
			}
		} else {
			this._hideContainer();
		}
	}

	_onError()
	{
		this._hideContainer();
	}
}